"use strict";
/*!
 *
 *  balloon.ts
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.$item = $('.st-Global_Item');
        this.balloon = '.st-Global_Balloon';
        this.arrow = '.st-Global_Balloon_Arrow';
        this.ww = document.querySelector('body').clientWidth;
        this.setPosition();
        this.setEvent();
        $(window).on('resize', function () {
            _this.setPosition();
        }).on('load', function () {
            _this.setPosition();
        });
    }
    default_1.prototype.setPosition = function () {
        var _this = this;
        this.ww = document.querySelector('body').clientWidth;
        this.$item.each(function (i, elem) {
            var $balloon = $(elem).find(_this.balloon);
            var bw = $balloon.width() / 2;
            var l = $(elem).offset().left;
            var w = $(elem).width() / 2;
            if (_this.ww < l + w + bw) {
                var ml = _this.ww - (l + w + bw);
                $balloon.css('margin-left', ml);
                var $arrow = $(elem).find(_this.arrow);
                $arrow.css('margin-left', Math.abs(ml) - 6);
            }
            ;
        });
    };
    default_1.prototype.setEvent = function () {
        var _this = this;
        var $target = this.$item.filter((function (i, elem) {
            return $(elem).find(_this.balloon).length !== 0;
        }));
        $target.on('mouseenter', function (e) {
            if (!util.isTouchDevice) {
                $(e.currentTarget).addClass('-expanded');
            }
            ;
        }).on('mouseleave', function (e) {
            if (!util.isTouchDevice) {
                $(e.currentTarget).removeClass('-expanded');
            }
            ;
        }).on('click', function (e) {
            if (util.isTouchDevice) {
                $target.not(e.currentTarget).removeClass('-expanded');
                $(e.currentTarget).toggleClass('-expanded');
            }
            ;
        });
        $('.st-Global_Link.-balloon').on('click', function (e) {
            e.preventDefault();
        });
        $(document).on('click', function (e) {
            if (util.isTouchDevice) {
                if (!$(e.target).closest('.st-Global_Item.-expanded').length) {
                    $('.st-Global_Item.-expanded').removeClass('-expanded');
                }
                ;
            }
            ;
        });
    };
    return default_1;
}());
exports.default = default_1;
;
